import * as cx from 'classnames'
import * as React from 'react'

import { IItemCard } from '../interface'

import FeatureContainer from '../../../containers/feature/featureContainer'
import ItemCardContentWithAttributesAndFiles from '../itemCardContentWithAttributesAndFiles'
import ItemCardSidebar from '../itemCardSidebar'
import ItemCardSquarePreview from '../itemCardSquarePreview'
import LockupPreviewActionPanel from '../lockupPreviewActionPanel'

import LockupFilesIncluded from '../lockupFilesIncluded'

import * as styles from './graphicRiverItemCard.module.css'

interface IState {
  collapsed: boolean
}

class GraphicRiverItemCard extends React.Component<IItemCard, IState> {
  public render() {
    const { item, rank, onItemLinkClick, viewType } = this.props

    const rootClass = cx(styles.root, {
      [styles.listView]: viewType === 'list',
      [styles.gridView]: viewType !== 'list'
    })

    return (
      <li className={rootClass}>
        <article className={styles.card}>
          <section className={styles.preview}>
            <ItemCardSquarePreview {...this.props} />
            <FeatureContainer name="!fileTypesOnItemCard">
              <section className={cx(styles.previewActionPanel, styles.hidden)}>
                <a
                  href={`${item.url}?s_rank=${rank}`}
                  onClick={onItemLinkClick}
                  className={styles.previewActionPanelClickHandler}
                  role="toolbar"
                  title={item.name}
                />
                <section className={styles.previewActionPanelActions}>
                  <LockupPreviewActionPanel {...this.props} />
                </section>
              </section>
            </FeatureContainer>
            <FeatureContainer name="fileTypesOnItemCard">
              <section className={styles.previewActionPanel}>
                <a
                  href={`${item.url}?s_rank=${rank}`}
                  onClick={onItemLinkClick}
                  className={styles.previewActionPanelClickHandler}
                  role="toolbar"
                  title={item.name}
                />
                <section className={styles.previewActionPanelActions}>
                  <div className={styles.previewActionPanelFileTypes}>
                    <LockupFilesIncluded {...this.props} />
                  </div>
                  <div className={styles.previewActionPanelButtons}>
                    <LockupPreviewActionPanel {...this.props} />
                  </div>
                </section>
              </section>
            </FeatureContainer>
          </section>
          <section className={styles.content}>
            <ItemCardContentWithAttributesAndFiles {...this.props} />
          </section>
          <section className={styles.sidebar}>
            <ItemCardSidebar {...this.props} />
          </section>
        </article>
      </li>
    )
  }
}

export default GraphicRiverItemCard
